import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M5.4 19.2c.461-.517 2.621-2.893 3.254-2.893h6.692c.918 0 2.79 1.97 3.254 2.664m3-6.971a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0Zm-6.161-3.272C15.439 6.896 13.893 5.4 12 5.4c-1.892 0-3.438 1.496-3.438 3.328s1.546 3.328 3.438 3.328 3.439-1.496 3.439-3.328Z"
    />
  </svg>
);
export default SvgUserProfileCircle;
